import React from 'react';
import { useScreenInit } from '../useScreenInit';
import { Logo } from '../components/ui/Logo';
import { FicheTPPanel, CertifTPPanel, FicheBTSPanel, CertifBTSPanel, ModalitesAccessPanel } from '../components/CataloguePanels';
export function Catalogue() {
  useScreenInit();
  return <div className="flex flex-col w-full bg-muted min-h-screen pb-24" data-id="element-839" data-mp="1onawff5j0ac4">
      <div className="container max-w-6xl mx-auto py-12 space-y-16" data-id="element-840" data-mp="1opndlq3gmgo4">
        {/* Page 1: Cover */}
        <div className="bg-white shadow-2xl overflow-hidden flex flex-col" data-id="element-841" data-mp="1aukx690zl8x2">
          <div className="h-28 flex items-center justify-center bg-white shrink-0" data-id="element-842" data-mp="1foguradc8trp">
            <div className="scale-[1.7] origin-center" data-id="element-843" data-mp="10zt1jaqysw4x">
              <Logo data-id="element-844" data-mp="15x2wf5x4i005" />
            </div>
          </div>
          <div className="flex-1 flex" data-id="element-845" data-mp="15xm47tt2780g">
            <div className="w-[55%] bg-primary-dark p-12 flex flex-col justify-center text-white relative" data-id="element-846" data-mp="rxtlaknrxw31">
              <div className="inline-block bg-brand-orange text-white font-heading font-bold px-4 py-2 text-sm tracking-wider mb-8 w-fit" data-id="element-847" data-mp="vzohxburflah">
                CATALOGUE DE FORMATIONS EN ALTERNANCE
              </div>
              <h1 className="text-5xl md:text-6xl font-heading font-extrabold leading-tight mb-8" data-id="element-848" data-mp="33hugztvhk3gw">
                CATALOGUE
                <br data-id="element-849" data-mp="3ifmwwn4y2tvm" />
                FORMATIONS
                <br data-id="element-850" data-mp="3dhbn2cengjde" />
                2026
              </h1>
              <p className="text-xl font-medium leading-relaxed max-w-md" data-id="element-851" data-mp="3dhtt20r46byi">
                Deux parcours professionnalisants en alternance, avec une
                information publique détaillée, vérifiable et accessible.
              </p>
            </div>
            <div className="w-[45%] bg-lavande p-12 flex items-center justify-center" data-id="element-852" data-mp="2zhj1evhzctca">
              <div className="bg-white p-10 w-full shadow-lg" data-id="element-853" data-mp="2uq0wjwcu68m1">
                <h2 className="text-2xl font-heading font-extrabold text-primary-dark mb-8" data-id="element-854" data-mp="2uopuc0z1h8x1">
                  SESSIONS OUVERTES
                </h2>
                <div className="space-y-6 mb-8" data-id="element-855" data-mp="220u0r54rnx4h">
                  <div className="border-l-4 border-brand-orange pl-4" data-id="element-856" data-mp="2202dqip8j7pt">
                    <h3 className="text-xl font-bold text-primary-dark" data-id="element-857" data-mp="2rpiv3ah9dls2">
                      BTS NDRC
                    </h3>
                    <p className="text-primary-dark font-medium" data-id="element-858" data-mp="2vp9n1hiiu7y6">
                      Session 2026–2028
                    </p>
                  </div>
                  <div className="border-l-4 border-brand-orange pl-4" data-id="element-859" data-mp="35g47qhg4czhi">
                    <h3 className="text-xl font-bold text-primary-dark" data-id="element-860" data-mp="28roeaa9w25z4">
                      TP Conseiller de Vente
                    </h3>
                    <p className="text-primary-dark font-medium" data-id="element-861" data-mp="2ct1nmuc6wras">
                      Session 2026–2027
                    </p>
                  </div>
                </div>
                <p className="text-sm text-primary-dark font-medium leading-relaxed" data-id="element-862" data-mp="2mrz6phqujsme">
                  Rentrée prévisionnelle : 25 septembre 2026, sous réserve de
                  places disponibles et de signature du contrat d'apprentissage.
                </p>
              </div>
            </div>
          </div>
          <div className="bg-primary-dark border-t border-white/10 p-6 text-center text-white shrink-0" data-id="element-863" data-mp="1mi7yx0skagq9">
            <p className="font-medium" data-id="element-864" data-mp="1hk6d483r43b3">
              Zillenium Alternance • 25 rue Gabriel Cortel – 89300 Joigny
              <br data-id="element-865" data-mp="1cqv3y0bgvag0" />
              09 83 49 01 81 • contact@zilleniumalternance.fr
            </p>
          </div>
        </div>

        {/* Page 2: Repères */}
        <div className="bg-lavande shadow-2xl overflow-hidden flex flex-col" data-id="element-866" data-mp="13tb1io1vb83t">
          <div className="bg-primary-dark p-8 flex justify-between items-center shrink-0" data-id="element-867" data-mp="ysncg7x791c8">
            <div data-id="element-868" data-mp="tttx09ycr09f">
              <p className="text-brand-orange font-bold text-sm tracking-wider mb-1" data-id="element-869" data-mp="ttail37wuu05">
                INFORMATION PUBLIQUE AVANT INSCRIPTION
              </p>
              <h2 className="text-3xl font-heading font-extrabold text-white" data-id="element-870" data-mp="oxdbzomg920k">
                REPÈRES CANDIDATS ET ENTREPRISES
              </h2>
            </div>
            <div className="bg-brand-orange text-white font-bold px-6 py-2" data-id="element-871" data-mp="2j9jnkoj99kte">
              Catalogue 2026
            </div>
          </div>
          <div className="flex-1 flex p-8 gap-8" data-id="element-872" data-mp="2w8ss4u2irgfj">
            <div className="w-1/2 flex flex-col" data-id="element-873" data-mp="2w7hr320gkms4">
              <h3 className="text-2xl font-heading font-extrabold text-primary-dark mb-4" data-id="element-874" data-mp="2hbjx9qe0buj2">
                OFFRE PUBLIÉE
              </h3>
              <p className="text-primary-dark font-bold mb-6" data-id="element-875" data-mp="2m9liaguzu3x6">
                Zillenium Alternance présente uniquement les formations ouvertes
                sur les sessions confirmées.
              </p>
              <div className="flex-1 flex flex-col gap-1 text-sm" data-id="element-876" data-mp="2daq8yvwnkdpn">
                <div className="flex border-b border-primary/20 pb-2 mb-2" data-id="element-877" data-mp="1ylkbpdhdkxke">
                  <div className="w-1/3 font-bold text-primary-dark" data-id="element-878" data-mp="23k52yneng6wp">
                    FORMATIONS
                  </div>
                  <div className="w-2/3 text-primary-dark" data-id="element-879" data-mp="1pjud9np2syd4">
                    TP Conseiller de Vente 2026–2027 ; BTS NDRC 2026–2028.
                  </div>
                </div>
                <div className="flex border-b border-primary/20 pb-2 mb-2" data-id="element-880" data-mp="1axneauoirlkg">
                  <div className="w-1/3 font-bold text-primary-dark" data-id="element-881" data-mp="1azrlblhpt0oy">
                    PUBLIC
                  </div>
                  <div className="w-2/3 text-primary-dark" data-id="element-882" data-mp="1jybt3rlqlpye">
                    Candidats en alternance, entreprises d'accueil et
                    prescripteurs.
                  </div>
                </div>
                <div className="flex border-b border-primary/20 pb-2 mb-2" data-id="element-883" data-mp="1tvzs4tqdljmd">
                  <div className="w-1/3 font-bold text-primary-dark" data-id="element-884" data-mp="1tu6mnhri15fy">ACCÈS</div>
                  <div className="w-2/3 text-primary-dark" data-id="element-885" data-mp="1ox6ft4mtryns">
                    Candidature, entretien, positionnement, validation du projet
                    et contrat.
                  </div>
                </div>
                <div className="flex border-b border-primary/20 pb-2 mb-2" data-id="element-886" data-mp="1yply6321ap97">
                  <div className="w-1/3 font-bold text-primary-dark" data-id="element-887" data-mp="2cnafj0ww7e9i">
                    TARIF APPRENTI
                  </div>
                  <div className="w-2/3 text-primary-dark" data-id="element-888" data-mp="15ai6g78cxh4q">
                    0 € pour l'apprenti sous contrat, financement selon OPCO.
                  </div>
                </div>
                <div className="flex border-b border-primary/20 pb-2 mb-2" data-id="element-889" data-mp="199qx3383oyw2">
                  <div className="w-1/3 font-bold text-primary-dark" data-id="element-890" data-mp="1e9myqvtbse8g">
                    RYTHME
                  </div>
                  <div className="w-2/3 text-primary-dark" data-id="element-891" data-mp="1j3r9zr9mj8fc">
                    Alternance école / entreprise, modalités précisées dans
                    chaque fiche.
                  </div>
                </div>
                <div className="flex border-b border-primary/20 pb-2 mb-2" data-id="element-892" data-mp="1x1o6kno2veu0">
                  <div className="w-1/3 font-bold text-primary-dark" data-id="element-893" data-mp="1wzl77d11c9cm">
                    MOYENS
                  </div>
                  <div className="w-2/3 text-primary-dark" data-id="element-894" data-mp="2noezhurqzgi">
                    Cours, ateliers, cas pratiques, mises en situation et suivi
                    individualisé.
                  </div>
                </div>
              </div>
              <div className="bg-primary-dark text-white p-4 mt-4 text-sm font-medium" data-id="element-895" data-mp="4a3wd8dasmj">
                <span className="text-brand-orange font-bold" data-id="element-896" data-mp="3rhmkh676icdv">
                  Avant l'entrée en formation :
                </span>{' '}
                le candidat reçoit le programme, les modalités d'accès, les
                prérequis, les conditions tarifaires, les contacts utiles et les
                informations relatives à la certification visée.
              </div>
            </div>
            <div className="w-1/2 flex flex-col" data-id="element-897" data-mp="e2qdcbxm6x8d">
              <h3 className="text-2xl font-heading font-extrabold text-primary-dark mb-4" data-id="element-898" data-mp="e0x0ug0blisg">
                CERTIFICATION ET RÉSULTATS
              </h3>
              <p className="text-primary-dark font-bold mb-6" data-id="element-899" data-mp="51a07wff0h0g">
                Chaque fiche mentionne la certification professionnelle visée,
                ses blocs et le lien officiel vérifiable.
              </p>
              <div className="flex-1 flex flex-col gap-1 text-sm" data-id="element-900" data-mp="2prr75aaibieo">
                <div className="flex border-b border-primary/20 pb-2 mb-2" data-id="element-901" data-mp="sremw9qvytp8">
                  <div className="w-1/3 font-bold text-primary-dark" data-id="element-902" data-mp="xqzq4wd39o7r">
                    TP VENTE
                  </div>
                  <div className="w-2/3 text-primary-dark" data-id="element-903" data-mp="js00pmhr55aj">
                    RNCP37098, niveau 4, Ministère chargé de l'emploi, échéance
                    25/01/2028.
                  </div>
                </div>
                <div className="flex border-b border-primary/20 pb-2 mb-2" data-id="element-904" data-mp="1cgyniwwtkvm6">
                  <div className="w-1/3 font-bold text-primary-dark" data-id="element-905" data-mp="1gi0l79b38zm1">
                    BTS NDRC
                  </div>
                  <div className="w-2/3 text-primary-dark" data-id="element-906" data-mp="12paz74vk7uox">
                    RNCP38368, niveau 5, Ministère chargé de l'enseignement
                    supérieur, échéance 31/12/2028.
                  </div>
                </div>
                <div className="flex border-b border-primary/20 pb-2 mb-2" data-id="element-907" data-mp="1vcopik4r5s02">
                  <div className="w-1/3 font-bold text-primary-dark" data-id="element-908" data-mp="2071aiylvnbdx">
                    RÉSULTATS TP
                  </div>
                  <div className="w-2/3 text-primary-dark" data-id="element-909" data-mp="29hxco17jn3xi">
                    Session 2024–2025 : 100 %. Session 2026–2027 : examen à
                    venir.
                  </div>
                </div>
                <div className="flex border-b border-primary/20 pb-2 mb-2" data-id="element-910" data-mp="2jbxt2z89zvlj">
                  <div className="w-1/3 font-bold text-primary-dark" data-id="element-911" data-mp="2ebs2znhnmh5k">
                    RÉSULTATS BTS
                  </div>
                  <div className="w-2/3 text-primary-dark" data-id="element-912" data-mp="1mju6hu0iihoy">
                    Sessions 2025–2027 et 2026–2028 : examens prévus en 2027 et
                    2028.
                  </div>
                </div>
                <div className="flex border-b border-primary/20 pb-2 mb-2" data-id="element-913" data-mp="1vksdml68z5br">
                  <div className="w-1/3 font-bold text-primary-dark" data-id="element-914" data-mp="1vmv9vmxztuox">
                    ACCESSIBILITÉ
                  </div>
                  <div className="w-2/3 text-primary-dark" data-id="element-915" data-mp="370789iazhl3p">
                    Étude individualisée des besoins et adaptation possible du
                    parcours.
                  </div>
                </div>
                <div className="flex border-b border-primary/20 pb-2 mb-2" data-id="element-916" data-mp="1ur0s9lhwvgt2">
                  <div className="w-1/3 font-bold text-primary-dark" data-id="element-917" data-mp="1pyzh62whbw4m">
                    MISE À JOUR
                  </div>
                  <div className="w-2/3 text-primary-dark" data-id="element-918" data-mp="1kz4vcdrk9wqf">
                    Les indicateurs sont actualisés après les sessions
                    réellement présentées.
                  </div>
                </div>
              </div>
              <div className="bg-primary-dark text-white p-4 mt-4 text-sm font-medium" data-id="element-919" data-mp="1c1ks4za51qd6">
                <span className="text-brand-orange font-bold" data-id="element-920" data-mp="170n8ei9hco9k">Contacts :</span>{' '}
                09 83 49 01 81 • contact@zilleniumalternance.fr • Référent
                handicap : samir@zilleniumalternance.fr.
              </div>
            </div>
          </div>
          <div className="bg-lavande/50 p-6 text-center text-primary-dark shrink-0 font-bold" data-id="element-921" data-mp="2wgeawp7kk4mg">
            <p data-id="element-922" data-mp="34x53vt5ggmxo">
              Zillenium Alternance • 25 rue Gabriel Cortel, 89300 Joigny •
              Catalogue public des formations en alternance
            </p>
          </div>
        </div>

        {/* Page 3: Fiche TP */}
        <FicheTPPanel data-id="element-923" data-mp="3dp72dlvyrt5b" />

        {/* Page 4: Certif TP */}
        <CertifTPPanel data-id="element-924" data-mp="3ioa1yqt6d75w" />

        {/* Page 5: Fiche BTS */}
        <FicheBTSPanel data-id="element-925" data-mp="3ipl2mhrbpyss" />

        {/* Page 6: Certification BTS NDRC */}
        <CertifBTSPanel data-id="element-926" data-mp="2lz2dpb168jya" />

        {/* Page 7: Modalités d'accès */}
        <ModalitesAccessPanel data-id="element-927" data-mp="2pyb6odoe0dss" />
      </div>
    </div>;
}